import moment from 'moment';
import * as actions from './actions';
import {
    SHORT_DATE_FORMAT,
    DATE_TIME_TIMEZONE_FORMAT,
    EMPTY_VALUE,
    SELECTED_DATE_PICKER_VALUE_TYPE
} from './constants';

const defaultSummary = {
    goldCount: 0,
    silverCount: 0,
    bronzeCount: 0,
    totalCount: 0
};

const initState = {
    classroomGroups: [],
    academicYear: {
        startDate: null,
        endDate: null
    },
    currentDate: {
        type: SELECTED_DATE_PICKER_VALUE_TYPE,
        startDate: null,
        endDate: null
    },
    isDownloading: false,
    isDownloadSuccess: false,
    isFail: false,
    selectedTeacherId: EMPTY_VALUE,
    summary: defaultSummary
};

export default function (state = initState, action) {
    switch (action.type) {
    case actions.DOWNLOAD_CERTIFICATES_REQUEST: {
        return { ...state,
            isDownloading: true,
            isDownloadSuccess: false,
            isFail: false
        };
    }

    case actions.DOWNLOAD_CERTIFICATES_SUCCESS: {
        return { ...state,
            isDownloading: false,
            isDownloadSuccess: true,
            isFail: false
        };
    }

    case actions.DOWNLOAD_CERTIFICATES_FAILURE: {
        return { ...state,
            isDownloading: false,
            isDownloadSuccess: false,
            isFail: true
        };
    }

    case actions.SET_TEACHER_ID: {
        const newState = {
            ...state,
            selectedClassroomId: EMPTY_VALUE,
            selectedGroupId: EMPTY_VALUE,
            selectedTeacherId: action.selectedTeacherId
        };
        return newState;
    }

    case actions.SET_CLASSROOM_ID: {
        const newState = {
            ...state,
            selectedClassroomId: action.selectedClassroomId,
            selectedGroupId: EMPTY_VALUE
        };
        if (action.selectedClassroomId === EMPTY_VALUE) {
            newState.summary = defaultSummary;
        }
        return newState;
    }

    case actions.SET_GROUP_ID: {
        const newState = {
            ...state,
            selectedGroupId: action.selectedGroupId
        };
        if (action.selectedGroupId === EMPTY_VALUE) {
            newState.summary = defaultSummary;
        }
        return newState;
    }

    case actions.GET_CLASSROOM_GROUPS_REQUEST: {
        return {
            ...state,
            fetchingClassroomGroups: true,
            fetchingClassroomGroupsSuccess: false,
            fetchingClassroomGroupsFail: false
        };
    }

    case actions.GET_CLASSROOM_GROUPS_SUCCESS: {
        return {
            ...state,
            fetchingClassroomGroups: false,
            fetchingClassroomGroupsSuccess: true,
            fetchingClassroomGroupsFail: false,
            classroomGroups: action.data
        };
    }

    case actions.GET_CLASSROOM_GROUPS_FAILURE: {
        return {
            ...state,
            fetchingClassroomGroups: false,
            fetchingClassroomGroupsSuccess: false,
            fetchingClassroomGroupsFail: true
        };
    }

    case actions.CLEAR_CLASSROOM_GROUPS: {
        return {
            ...state,
            classroomGroups: [],
            selectedGroupId: EMPTY_VALUE
        };
    }

    case actions.GET_ACADEMIC_YEAR_REQUEST: {
        return {
            ...state,
            fetchingAcademicYear: true,
            fetchingAcademicYearSuccess: false,
            fetchingAcademicYearFailed: false
        };
    }

    case actions.GET_ACADEMIC_YEAR_SUCCESS: {
        const { startDate: oldStartDate, endDate: oldEndDate } = action.data;
        const startDate = moment(oldStartDate, DATE_TIME_TIMEZONE_FORMAT).format(SHORT_DATE_FORMAT);
        const endDate = moment(oldEndDate, DATE_TIME_TIMEZONE_FORMAT).format(SHORT_DATE_FORMAT);

        const academicYear = {
            startDate,
            endDate,
            raw: action.data
        };

        const newCurrentDate = {
            type: SELECTED_DATE_PICKER_VALUE_TYPE,
            startDate,
            endDate
        };

        return {
            ...state,
            academicYear,
            currentDate: { ...newCurrentDate },
            fetchingAcademicYear: false,
            fetchingAcademicYearSuccess: true,
            fetchingAcademicYearFailed: false
        };
    }

    case actions.GET_ACADEMIC_YEAR_FAILURE: {
        return {
            ...state,
            fetchingAcademicYear: false,
            fetchingAcademicYearSuccess: false,
            fetchingAcademicYearFailed: true
        };
    }

    case actions.GET_CERTIFICATES_SUMMARY_REQUEST: {
        return {
            ...state,
            fetchingSummary: true,
            fetchingSummarySuccess: false,
            fetchingSummaryFailed: false
        };
    }

    case actions.GET_CERTIFICATES_SUMMARY_SUCCESS: {
        const { goldCount, silverCount, bronzeCount } = action.data;
        const newTotalCount = goldCount + silverCount + bronzeCount;

        const newSummary = {
            ...action.data,
            totalCount: newTotalCount
        };
        return {
            ...state,
            summary: newSummary,
            fetchingSummary: false,
            fetchingSummarySuccess: true,
            fetchingSummaryFailed: false
        };
    }

    case actions.GET_CERTIFICATES_SUMMARY_FAILURE: {
        return {
            ...state,
            fetchingSummary: false,
            fetchingSummarySuccess: false,
            fetchingSummaryFailed: true
        };
    }

    case actions.ON_DATE_PICKER_CHANGE: {
        const newCurrentDate = {
            type: action.dateType,
            startDate: action.startDate,
            endDate: action.endDate
        };

        return {
            ...state,
            currentDate: newCurrentDate
        };
    }

    case actions.DOWNLOAD_CERTIFICATES_SETUP:
    default:
        return { ...state };
    }
}



// WEBPACK FOOTER //
// ./app/containers/download-certificates/reducer.js